import { PaymentsSection } from "@/components/dashboard/PaymentsSection";
import { ProfileSection } from "@/components/dashboard/ProfileSection";
import { RetailerProfileSection } from "@/components/dashboard/RetailerProfileSection";
import { SupplierDashboardHome } from "@/components/dashboard/SupplierDashboardHome";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { MessagingSection } from "@/components/messaging/MessagingSection";
import { AddProductForm } from "@/components/products/AddProductForm";
import { EditProductForm } from "@/components/products/EditProductForm";
import { SupplierProductList } from "@/components/products/SupplierProductList";
import { Skeleton } from "@/components/ui/skeleton";
import { useAuth } from "@/contexts/AuthContext";
import { useEffect, useState } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import OrdersList from "./OrdersList";
import OrderView from "./OrderView";

const DashboardHome = () => {
	const { isSupplier } = useAuth();

	if (isSupplier) {
		return <SupplierDashboardHome />;
	} else {
		return <Navigate to="/dashboard/profile" replace />;
	}
};

const Dashboard = () => {
	const { user, isLoading, isSupplier, isRetailer } = useAuth();
	const navigate = useNavigate();
	const [isReady, setIsReady] = useState(false);

	useEffect(() => {
		if (!isLoading) {
			if (!user) {
				navigate("/auth");
			} else {
				setIsReady(true);
			}
		}
	}, [user, isLoading, navigate]);

	if (isLoading || !isReady) {
		return (
			<div className="min-h-screen bg-gray-50 flex items-center justify-center">
				<div className="w-full max-w-md space-y-4 p-4">
					<Skeleton className="h-8 w-3/4 mx-auto" />
					<Skeleton className="h-4 w-2/3 mx-auto" />
					<div className="space-y-2">
						<Skeleton className="h-12 w-full" />
						<Skeleton className="h-12 w-full" />
						<Skeleton className="h-12 w-full" />
					</div>
				</div>
			</div>
		);
	}

	return (
		<DashboardLayout>
			<Routes>
				<Route path="/" element={<DashboardHome />} />
				<Route
					path="/products"
					element={
						isSupplier ? (
							<SupplierProductList />
						) : (
							<Navigate to="/dashboard" replace />
						)
					}
				/>
				<Route
					path="/products/add"
					element={
						isSupplier ? (
							<AddProductForm />
						) : (
							<Navigate to="/dashboard" replace />
						)
					}
				/>
				<Route
					path="/products/edit/:id"
					element={
						isSupplier ? (
							<EditProductForm />
						) : (
							<Navigate to="/dashboard" replace />
						)
					}
				/>
				<Route
					path="/profile"
					element={
						isSupplier ? (
							<ProfileSection />
						) : (
							<RetailerProfileSection />
						)
					}
				/>
				<Route path="/messages" element={<MessagingSection />} />
				<Route path="/orders" element={<OrdersList />} />
				<Route path="/orders/:id" element={<OrderView />} />
				<Route path="/payments" element={<PaymentsSection />} />
				<Route
					path="*"
					element={
						isRetailer ? (
							<Navigate to="/dashboard/profile" replace />
						) : (
							<Navigate to="/dashboard" replace />
						)
					}
				/>
			</Routes>
		</DashboardLayout>
	);
};

export default Dashboard;
